import React from 'react';
import BaseQuoteTabShow from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseQuoteTabShow/BaseQuoteTabShow";

export default function ProspectQuoteTabShow(props) {
    return (
        <BaseQuoteTabShow {...props}/>
    )
}
